import { useMemo } from "react";
import { McUserDao } from "./McUserDao";

export const useMcUserDao = () => {
  return useMemo(() => new McUserDao(), []);
};
